<template>
    <div class="workspace-area"
         @click.self="deactivateLayer">
        <workspace-area-left @setScale="scale = $event"
                             @openTemplateGroupManager="$emit('openTemplateGroupManager')"/>
        <workspace-area-center :scale.sync="scale"/>
        <workspace-area-right/>
        <workspace-area-bottom/>
    </div>
</template>

<script type="text/babel">
import { mapMutations, mapActions } from 'vuex';
import LayersMixin from '../../../../../mixins/LayersMixin.vue';
import DragAndDropMixin from '../../../../../mixins/DragAndDropMixin.vue';
import WorkspaceLayer from '../Layers/WorkspaceLayer.vue';
import WorkspaceAreaLeft from './Left/WorkspaceAreaLeft.vue';
import WorkspaceAreaCenter from './Center/WorkspaceAreaCenter.vue';
import WorkspaceAreaRight from './Right/WorkspaceAreaRight.vue';
import WorkspaceAreaBottom from './Bottom/WorkspaceAreaBottom.vue';
//eslint-disable-next-line

export default {
    name: 'Area',
    data () {
        return {
            activeLayer: {
                id: '',
                index: null
            },
            scale: 0.3
        };
    },
    props: {
        workspaceLayers: {
            type: Array
        }
    },
    
    components: {
        WorkspaceLayer,
        WorkspaceAreaLeft,
        WorkspaceAreaCenter,
        WorkspaceAreaRight,
        WorkspaceAreaBottom
    },
    mixins: [LayersMixin, DragAndDropMixin],
    methods: {
        ...mapActions(['getLayoutAsync', 'updateLayoutAsync']),
        ...mapMutations(['resetLayout']),
        setActiveLayer (id, index) {
            this.activeLayer = {
                id: id,
                index: index
            };
        },
        isActiveLayer (layerId) {
            return layerId === this.activeLayer.id;
        },
        removeLayer (index) {
            let newOrder = this.workspaceLayers;
            newOrder.splice(index, 1);
            this.$emit('update:workspaceLayers', newOrder);
        },
        deactivateLayer () {
            this.activeLayer = {
                id: '',
                index: null
            };
        }
    }
};

</script>

<style lang="scss">
    $grid-xs: 320px;
    $grid-sm: 480px;
    $grid-md: 768px;
    $grid-lg: 1000px;

    .workspace-area {
        height: 100%;
        display: flex;
    }
    
    .left {
        grid-area: left;
        @include color('background-color', primary);
    }
    
    .center {
        grid-area: center;
    }
    
    .right {
        grid-area: right;
        @include color('background-color', primary);
    }

    .bottom {
        grid-area: bottom;
        @include color('background-color', primary);
    }
    
    .workspace-area {
        display: grid;
   
        @media screen and (max-width: $grid-xs) {
            grid-template-columns: 50% 50%;
            grid-template-rows: 50% 50%;
            grid-template-areas:
                "right center"
                "left center";
        }
    
        @media screen and (min-width: $grid-xs) {
            grid-template-columns: 50% 50%;
            grid-template-rows: 50% 50%;
            grid-template-areas:
                "right center"
                "left center";
        }
    
        @media screen and (min-width: $grid-md) {
            grid-template-columns: 25% 50% 25%;
            grid-template-areas:
                "left center right"
                "left center right";
        }
    }
    
    .active-node {
        border: 2px solid red;
    }

</style>
